import { ref } from 'vue';

export const useHeatmapTooltip = () => {
  const visible = ref(false);
  const x = ref(0);
  const y = ref(0);
  const value = ref(0);

  const show = (event, nextValue) => {
    const { clientX = 0, clientY = 0 } = event;
    x.value = clientX;
    y.value = clientY;
    value.value = nextValue;
    visible.value = true;
  };

  const hide = () => {
    visible.value = false;
  };

  return { visible, x, y, value, show, hide };
};
